import React, { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import useGetApi from '../../../../../hooks/use-get-api';

interface SquareBoxProps {
  boxClassName?: string;
  headingClassName?: string;
  imageClssName?: string;
  heading?: string;
  lottieUrl?: string;
  SemiCircleClassName?: string;
}

const Lottie = dynamic(() => import('react-lottie'), {
  ssr: false,
});

const SquareBox = ({
  boxClassName = '',
  headingClassName = '',
  imageClssName = '',
  heading = 'Auto Import <br /> Investment Data',
  lottieUrl = 'https://assets.clear.in/cleartax/images/1757663830_autoimport.json',
  SemiCircleClassName = 'hidden',
}: SquareBoxProps) => {
  const boxRef = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const el = boxRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const { data: lottieAnimationData } = useGetApi(isInView ? lottieUrl : '');
  return (
    <div
      ref={boxRef}
      className={`${boxClassName} relative rounded-3xl overflow-hidden`}
    >
      <div
        className={`absolute w-full h-full rounded-full translate-y-1/2 ${SemiCircleClassName}`}
      ></div>
      <div
        className={`text-s-32 font-semibold text-center pt-12 lg:text-s-28 md:text-s-28 md:pt-10 sm:text-s-20 sm:pt-10 ${headingClassName}`}
        dangerouslySetInnerHTML={{ __html: heading }}
      />
      <div className={`${imageClssName}`}>
        <div className="pointer-events-none">
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: lottieAnimationData,
            }}
          />
        </div>{' '}
        <img src="" alt="" />
      </div>
    </div>
  );
};

export default SquareBox;
